/**
 * Bottom-left progress: which drones are fetching / decoding / rendering, with a thin bar. Reads the engine's
 * vanilla store; disappears ~1.5 s after everything is ready.
 */
import { useSyncExternalStore } from 'react';
import { engineStore, type LoadProgress } from '../../store/engineStore';
import { useDrones } from '../../store/dronesStore';

function useProgress(): Record<string, LoadProgress> {
  return useSyncExternalStore((cb) => engineStore.subscribe(cb), () => engineStore.getState().progress, () => engineStore.getState().progress);
}

export function LoadingIndicator() {
  const progress = useProgress();
  const byId = useDrones((s) => s.byId);
  const entries = Object.entries(progress);
  if (entries.length === 0) return null;
  return (
    <div className="glass glass--pill chrome-loading" role="status" aria-live="polite">
      {entries.map(([id, p]) => (
        <div key={id} className={`loading-row is-${p.phase}`}>
          <span className="loading-row__name">{byId(id)?.name ?? id}</span>
          <span className="loading-row__label">{p.phase === 'ready' ? 'ready' : p.phase === 'error' ? `couldn't load: ${p.label}` : p.label}</span>
          <span className="loading-row__bar" aria-hidden="true"><span style={{ width: `${Math.round(p.fraction * 100)}%` }} /></span>
        </div>
      ))}
    </div>
  );
}
